import React, {FC} from 'react';
import styled from 'styled-components';

import {SettingsDevelopersPagesEnum, SettingsDevelopersUrl} from '../../../models/url/settingsUrlModel';
import {SettingsPanelId} from '../../../store/panels/panelStateBase';
import {SettingsDevelopersInfoBoxContainer} from '../settingsDevelopersInfoBoxContainer';
import {SettingsDevelopersAllAppsPage} from './allApps/settingsDevelopersAllAppsPage';
import {SettingsDevelopersApiTokensPage} from './apiTokens/settingsDevelopersApiTokensPage';
import {SettingsDevelopersApplicationPageContainer} from './application/settingsDevelopersApplicationPageContainer';

/*
 * Props.
 */

interface SettingsDevelopersPagesProps {
  panelId: SettingsPanelId;
  url: SettingsDevelopersUrl;
}

/*
 * Style.
 */

const StyledDevelopersPageWrapperDiv = styled.div`
  flex: 1;
  display: flex;
  flex-flow: row;
  gap: 16px;
  position: relative;
  overflow: hidden;
`;

const StyledDevelopersContentWrapperDiv = styled.div`
  display: flex;
  flex: 1;
  overflow: auto;
`;

/*
 * Component.
 */

export const SettingsDevelopersPages: FC<SettingsDevelopersPagesProps> = (props) => {
  const {panelId, url} = props;
  return (
    <StyledDevelopersPageWrapperDiv>
      <StyledDevelopersContentWrapperDiv>{renderPage(url, panelId)}</StyledDevelopersContentWrapperDiv>
      <SettingsDevelopersInfoBoxContainer url={url} />
    </StyledDevelopersPageWrapperDiv>
  );
};

/*
 * Helpers.
 */

function renderPage(url: SettingsDevelopersUrl, panelId: SettingsPanelId) {
  switch (url.subPage) {
    case SettingsDevelopersPagesEnum.APPLICATION_INFO:
    case SettingsDevelopersPagesEnum.APPLICATION_FEATURES:
    case SettingsDevelopersPagesEnum.APPLICATION_OAUTH:
    case SettingsDevelopersPagesEnum.APPLICATION_SERVERS:
      return <SettingsDevelopersApplicationPageContainer url={url} panelId={panelId} />;
    case SettingsDevelopersPagesEnum.TOKENS:
      return <SettingsDevelopersApiTokensPage url={url} panelId={panelId} />;
    case SettingsDevelopersPagesEnum.APPLICATIONS:
    default:
      return <SettingsDevelopersAllAppsPage url={url} panelId={panelId} />;
  }
}
